import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/sanibiz.png" 
              alt="SANIBIZ MIS" 
              className="h-12 w-auto"
            />
            <div className="hidden sm:block">
              <div className="text-xs text-gray-500 -mt-1">Where Automation Meets Accuracy</div>
            </div>
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center space-x-6">
            <Link
              to="/"
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Home
            </Link>
            <Link
              to="/terms-of-use"
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Terms
            </Link>
            <Link
              to="/privacy-policy"
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
